import { getPageDescriptor } from '@pm2/api';
import { findPageDescriptorById } from './util.find-page-descriptor-by-id.js';

function getPagePathById(configStore, sitemap, pageId) {
  const pageDescriptor = findPageDescriptorById(sitemap, pageId);
  if (pageDescriptor) {
    return pageDescriptor.path;
  }
  const configState = configStore.getState();
  const descriptor = getPageDescriptor(configState.config, pageId, {
    previewMode: configState.previewMode
  });
  if (descriptor instanceof Promise) {
    return descriptor.then((it) => it == null ? void 0 : it.path);
  } else {
    return descriptor == null ? void 0 : descriptor.path;
  }
}

export { getPagePathById };
//# sourceMappingURL=util.get-page-by-id.js.map
